import React from "react";
import { CheckCircle2, LoaderCircle } from "lucide-react";
import "./PasswordStrengthChecklist.css";

export function getPasswordRules(password = "") {
  return [
    {
      key: "length",
      label: "At least 8 characters",
      valid: password.length >= 8,
    },
    {
      key: "uppercase",
      label: "At least one uppercase letter",
      valid: /[A-Z]/.test(password),
    },
    {
      key: "lowercase",
      label: "At least one lowercase letter",
      valid: /[a-z]/.test(password),
    },
    { key: "number", label: "At least one number", valid: /\d/.test(password) },
    {
      key: "special",
      label: "At least one special character",
      valid: /[^A-Za-z0-9]/.test(password),
    },
  ];
}

export function isStrongPassword(password = "") {
  return getPasswordRules(password).every((rule) => rule.valid);
}

export default function PasswordStrengthChecklist({
  password = "",
  variant = "default",
}) {
  const rules = getPasswordRules(password);
  const remainingRules = rules.filter((rule) => !rule.valid);

  if (!password || remainingRules.length === 0) return null;

  return (
    <div className={`password-checklist password-checklist--${variant}`}>
      {remainingRules.map((rule) => (
        <div key={rule.key} className="password-checklist__rule">
          <LoaderCircle size={15} className="password-checklist__loader" />
          <span>{rule.label}</span>
        </div>
      ))}

      {rules
        .filter((rule) => rule.valid)
        .map((rule) => (
          <div key={rule.key} className="password-checklist__rule valid">
            <CheckCircle2 size={15} />
            <span>{rule.label}</span>
          </div>
        ))}
    </div>
  );
}
